import { useCallback } from "react";
import useDeepEffect from "shared/hooks/useDeepEffect";
import {
  CanvasProcessing,
  IDimension,
  IPublishCanvasStatus,
} from "shared/types/designStudio";
import { toJSON } from "../canvas.utils/Parsers";
import { CANVAS_MARGIN } from "./useCanvas";

type Args = {
  onComplete?: (json: any, isPublishing: boolean) => void;
  canvas?: fabric.Canvas;
  wrapperDiv: HTMLDivElement | null;
  dimension: IDimension;
  savingDraft: CanvasProcessing;
  publishCanvasStatus: IPublishCanvasStatus | null;
};

export default (args: Args) => {
  const {
    canvas,
    dimension,
    wrapperDiv,
    publishCanvasStatus,
    savingDraft,
    onComplete,
  } = args;
  const getSerializingProps = useCallback(
    () => ({
      originalDimension: dimension,
      wrapperDiv,
      CANVAS_MARGIN,
    }),
    [dimension, wrapperDiv],
  );

  useDeepEffect(() => {
    const okToProceed =
      savingDraft === "SAVE_FIRED" || publishCanvasStatus?.status === "BEGIN";
    if (!okToProceed) return;

    canvas
      ?.getObjects()
      .filter(obj => obj.type === "textbox")
      .forEach(obj => (obj as fabric.Textbox).exitEditing());

    const shouldPublish = publishCanvasStatus?.status === "BEGIN";
    toJSON({ canvas, ...getSerializingProps() }).then(json =>
      onComplete?.(json, shouldPublish),
    );
  }, [canvas, savingDraft, getSerializingProps, publishCanvasStatus]);
};
